import { createContext, useContext, useState } from "react";
import styled from "styled-components";
import { P2 } from "./Typography";
import { useEffect } from "react";
import theme from "../common/theme";

export const TabContext = createContext({
    active: 0,
    setActive: () => { }
})

export const TabContainer = styled(({ initialTab = 0, ...props }) => {
    const [active, setActive] = useState(initialTab);
    useEffect(() => {
        setActive(initialTab);
    }, [initialTab])
    return <TabContext.Provider value={{ active, setActive }}><div {...props} /></TabContext.Provider>
})`
    display: flex;
    flex-direction: column;
`

export const Tab = styled(({ tabId, ...props }) => {
    const context = useContext(TabContext);
    const active = tabId === context.active;
    return <P2
        {...props}
        style={{
            color: active ? theme.palette.text : theme.palette.border,
            borderBottomColor: active ? theme.palette.text : theme.palette.border
        }}
        onClick={() => {
            context.setActive(tabId)
            if (props.onClick) { props.onClick(); }
        }}
    />
})`
    // flex: 1;
    padding-right: 1rem;
    padding-left: 1rem;
    display: flex;
    cursor: pointer;
    justify-content: center;
    font-family: "Roboto Condensed";
    font-size: 16px;
    font-weight: 700;
    text-decoration: none;    
    padding-bottom: 0.25rem;

    border-bottom-style: solid;
    border-bottom-width: 2px;
`;

export const EmptyTab = styled.div`
    border-bottom: 2px solid ${theme.palette.border};
    flex: 1;
    align-self: flex-end;
`

export const TabContent = styled(({ tabId, ...props }) => {
    return (
        <TabContext.Consumer>
            {(context) => {
                if (context.active !== tabId) {
                    return null;
                }
                return <div {...props} />
            }}
        </TabContext.Consumer>
    )
})`
    flex: 4;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;